import { render, staticRenderFns } from "./diceroller.vue?vue&type=template&id=bf0adc3e&scoped=true&"
import script from "./diceroller.vue?vue&type=script&lang=js&"
export * from "./diceroller.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf0adc3e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/fcs/fcs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bf0adc3e')) {
      api.createRecord('bf0adc3e', component.options)
    } else {
      api.reload('bf0adc3e', component.options)
    }
    module.hot.accept("./diceroller.vue?vue&type=template&id=bf0adc3e&scoped=true&", function () {
      api.rerender('bf0adc3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/diceroller.vue"
export default component.exports